import {
  Events,
  GridApi,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'

const template = `
<div  class="ag-status-bar-right" role="status"><div class="ag-status-panel ag-status-panel-aggregations">
<!--AG-NAME-VALUE--><div class="ag-status-name-value">
<span>Average</span>:&nbsp;
<span class="ag-status-name-value-value avg">0</span>
</div>
<!--AG-NAME-VALUE--><div class="ag-status-name-value">
<span>Count</span>:&nbsp;
<span class="ag-status-name-value-value count">0</span>
</div>
<!--AG-NAME-VALUE--><div class="ag-status-name-value">
<span>Min</span>:&nbsp;
<span class="ag-status-name-value-value min">NA</span>
</div>
<!--AG-NAME-VALUE--><div class="ag-status-name-value">
<span>Max</span>:&nbsp;
<span class="ag-status-name-value-value max">NA</span>
</div>
<!--AG-NAME-VALUE--><div class="ag-status-name-value">
<span>Sum</span>:&nbsp;
<span class="ag-status-name-value-value sum">0</span>
</div>
</div></div>
  `

export class CustomAggregateBarComponent implements IStatusPanelComp {
  private api!: GridApi
  private guiElement!: HTMLElement

  /** @internal */
  readonly listener = () => this.onSelectionChanged()

  init(params: IStatusPanelParams): void {
    this.api = params.api
    params.api.addEventListener(Events.EVENT_SELECTION_CHANGED, this.listener)
  }

  destroy() {
    this.api.removeEventListener(Events.EVENT_SELECTION_CHANGED, this.listener)
  }

  getGui(): HTMLElement {
    const el = loadTemplate(template)
    this.guiElement = el
    return el
  }

  /** @internal */
  onSelectionChanged() {
    // funny enough, ag-grid does have a bug where the last row isn't fired until after this selectionChanged event is fired
    setTimeout(() => {
      const cellRanges = this.api.getCellRanges()
      let count = 0
      let sum = 0
      let max = Number.MIN_SAFE_INTEGER
      let min = Number.MAX_SAFE_INTEGER
      let totalNumbers = 0
      let avg = 0
      cellRanges?.forEach(cellRange => {
        let startRow = cellRange.startRow?.rowIndex ?? 0
        let endRow = cellRange.endRow?.rowIndex ?? 0
        if (startRow > endRow) {
          // no extra variable swap
          startRow += endRow
          endRow = startRow - endRow
          startRow = startRow - endRow
        }

        for (let row = startRow; row <= endRow; row++) {
          const rowNode = this.api.getDisplayedRowAtIndex(row)
          cellRange.columns.forEach(column => {
            count++
            const dataValue = Number(
              this.numberDelimiterFormatter(rowNode?.data[column.getColId()]),
            )
            if (!isNaN(dataValue)) {
              sum += dataValue
              max = dataValue > max ? dataValue : max
              min = dataValue < min ? dataValue : min
              totalNumbers++
            }
          })
        }
      })

      //post processing
      if (totalNumbers > 0) {
        avg = Number((sum / totalNumbers).toFixed(2))
      }

      //set values
      const countSpan = this.guiElement.querySelector('.count') as HTMLElement
      countSpan.innerText = `${count}`

      const avgSpan = this.guiElement.querySelector('.avg') as HTMLElement
      avgSpan.innerText = `${avg}`

      const maxSpan = this.guiElement.querySelector('.max') as HTMLElement
      maxSpan.innerText = `${max == Number.MIN_SAFE_INTEGER ? 'NA' : max}`

      const minSpan = this.guiElement.querySelector('.min') as HTMLElement
      minSpan.innerText = `${min == Number.MAX_SAFE_INTEGER ? 'NA' : min}`

      const sumSpan = this.guiElement.querySelector('.sum') as HTMLElement
      sumSpan.innerText = `${sum}`
    }, 1)
  }

  numberDelimiterFormatter = (value: string) => {
    if (/^(-)?\d{1,3}(,\d{3})*(\.\d+)?$/.test(value)) {
      const number = parseFloat(value.replace(/,/g, ''))
      return number.toString()
    } else {
      return value
    }
  }
}
